import { useQuery } from '@tanstack/react-query'
import { data } from '@portal/pkg-api/shared'
import { SharedApi } from '@portal/pkg-api/navigator'

const prefix = 'admin.perspectives'

export const PerspectiveQueries = {
  sharedPerspectives: (entityTypeId: number) => ({
    queryKey: [`${prefix}.sharedPerspectives`, entityTypeId],
    queryFn: () => data(SharedApi.getPerspectives(entityTypeId)),
  }),
}

export function useSharedPerspectives(entityType: number) {
  return useQuery({
    ...PerspectiveQueries.sharedPerspectives(entityType),
    enabled: entityType !== -1,
    select: (perspectives) => perspectives.filter((p) => p.shared),
  })
}
